import { createContext, useContext } from 'react'

import { validateContext } from 'shared/utils'

export const PreviewSidePanelStateContext = createContext({})
export const PreviewSidePanelActionsContext = createContext({})

export const usePreviewSidePanelState = () => validateContext(useContext(PreviewSidePanelStateContext), {
  contextName: 'PreviewSidePanelStateContext',
  providerName: 'PreviewSidePanelProvider'
})

const usePreviewSidePanelActions = () => validateContext(useContext(PreviewSidePanelActionsContext), {
  contextName: 'PreviewSidePanelActionsContext',
  providerName: 'PreviewSidePanelProvider'
})

export const usePreviewSidePanel = () => {
  const state = usePreviewSidePanelState()
  const actions = usePreviewSidePanelActions()

  return {
    ...state,
    ...actions
  }
}
